<template>
  <div
    :class=" data.free == true ? 'plan-card-free':'plan-card'"
    v-bind:style="{
    'border-color': data.border,
    'border': 'solid 1px '+data.border,
    'border-radius': '5px'
  }"
  >
    <div v-show="data.free == true" class="plan-card-corner">
      <span class="text">FREE</span>
    </div>
    <div v-show="data.recommended == true" class="plan-card-topright">Recommended</div>
    <div class="plan-card-pricing">
      ₹ : {{data.pricing}}
      <span v-if="data.pricing > 0" style="font-size:16px">/ year</span>
    </div>
    <div class="plan-card-name">{{data.name}}</div>
    <div class="plan-card-name-subtext">Features you get</div>
    <ul class="plan-card-features">
      <li
        class="plan-card-feature"
        v-for="(feature, index) in data.features"
        :key="data.id+'feature'+index"
      >{{ feature }}</li>
    </ul>
    <v-btn x-large v-if="data.active" class="plan-card-active" text color="#68d391">
      ACTIVE
      <v-icon color="#68d391" style="margin-left:5px;">mdi-check-circle-outline</v-icon>
    </v-btn>
    <v-btn
      v-show="data.purchasable && !data.active"
      class="plan-card-cta"
      id="submit"
      @click="buy(data)"
    >BUY</v-btn>
    <v-btn class="plan-card-learn" text @click="learn(data)">Learn More</v-btn>
  </div>
</template>

<script>
export default {
  name: "Plan",
  props: ["data"],
  methods: {
    learn: function(data) {
      this.$emit("learn", data);
    },
    buy: function(data) {
      this.$emit("buy", data);
    }
  }
};
</script>